import { render, staticRenderFns } from "./ContractDisputesResolutionWidget.view.vue?vue&type=template&id=88dfb7d4&scoped=true&"
import script from "./ContractDisputesResolutionWidget.view.vue?vue&type=script&lang=js&"
export * from "./ContractDisputesResolutionWidget.view.vue?vue&type=script&lang=js&"
import style0 from "./ContractDisputesResolutionWidget.view.vue?vue&type=style&index=0&id=88dfb7d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dfb7d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88dfb7d4')) {
      api.createRecord('88dfb7d4', component.options)
    } else {
      api.reload('88dfb7d4', component.options)
    }
    module.hot.accept("./ContractDisputesResolutionWidget.view.vue?vue&type=template&id=88dfb7d4&scoped=true&", function () {
      api.rerender('88dfb7d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/update/ContractDisputesResolutionWidget.view.vue"
export default component.exports